import React from "react";
import PropTypes from "prop-types";

export default class Spacer extends React.Component {
  state = {};
  render() {
    return <div style={{ width: "100%", height: this.props.height }} />;
  }
}

Spacer.propTypes = {
  height: PropTypes.number
};
